import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { authActions } from "../../store/auth";
import useHttp from "../../hooks/use-http";
import { endPoints } from "../../config/end-points";
import "./tutorials.css";

const Tutorials = () => {
  const [tutorials, setTutorials] = useState([]);
  const dispatch = useDispatch();
  const { sendRequest } = useHttp();

  useEffect(() => {
    document.title = `${endPoints.title} | Tutorials`;
    dispatch(authActions.setLoaderStatus({ status: false }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    sendRequest(
      { url: endPoints.tutorials, method: "GET" },
      (response) => {
        if (response && response.length >= 1) {
          setTutorials(response);
        }
      }
    );
  }, [sendRequest]);

  return (
    <section className="tut-page">
      <div className="container">
        {/* Header */}
        <div className="tut-header">
          <h2>Tutorials</h2>
          <p>
            Learn how to get the most out of the platform
            {tutorials.length > 0 && (
              <span className="tut-count">
                <i className="bi bi-play-circle"></i>
                {tutorials.length} video{tutorials.length !== 1 ? "s" : ""}
              </span>
            )}
          </p>
        </div>

        {/* Tutorial Cards */}
        {tutorials.length > 0 ? (
          <div className="tut-grid">
            {tutorials.map((tut) => (
              <div className="tut-card" key={tut.name}>
                {/* Card Header */}
                <div className="tut-card-header">
                  <div className="tut-card-icon">
                    {tut.url ? (
                      <i className="bi bi-play-fill"></i>
                    ) : (
                      <i className="bi bi-book"></i>
                    )}
                  </div>
                  <h5 className="tut-card-title">{tut.name}</h5>
                </div>

                {/* Video Embed */}
                {tut.url && tut.url.length > 0 && (
                  <div className="tut-video-wrap">
                    <iframe
                      title={tut.name}
                      src={tut.url}
                      allowFullScreen
                    ></iframe>
                  </div>
                )}

                {/* Knowledgebase Link */}
                {tut.link && tut.link.length > 0 && (
                  <div className="tut-card-footer">
                    {tut.url && tut.url.length > 0 && (
                      <span className="tut-divider">or</span>
                    )}
                    <a
                      className="tut-link-btn"
                      href={tut.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="bi bi-box-arrow-up-right"></i>
                      Open Knowledgebase
                    </a>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="tut-empty">
            <div className="tut-empty-icon">
              <i className="bi bi-camera-video"></i>
            </div>
            <h5>Tutorials coming soon</h5>
            <p>We're preparing video guides and documentation to help you build amazing websites.</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default Tutorials;
